export default __webpack_public_path__ + "static/media/cl4.3d4cd368.webp";